import { createActions } from 'redux-actions';
import { Hospital } from '@models/BusinessPartner';
import { HospitalNetworkSearchParams } from '@apis/HospitalNetworkApi';
import { Pagination } from '@models/Pagination';

export type State = {
  hospitals?: Hospital[] | null;
  isLoading?: boolean;
  error?: string | null;
  pagination?: Pagination | null;
  searchParams?: HospitalNetworkSearchParams;
};

export type StateUpdatePayload = Partial<State>;

export type HospitalsFetchPayload = HospitalNetworkSearchParams;

export const {
  hospitalsFetch,
  stateUpdate,
} = createActions(
  'HOSPITALS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'HOSPITAL_NETWORK_PAGE',
  },
);
